import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router';
import { CircularProgress, Stack } from '@mui/material';
import RootLayout from './components/layout/RootLayout';
import { TeamDrawerProvider } from './contexts/TeamDrawerContext';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ArticlesPage = lazy(() => import('./pages/ArticlesPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function PageLoader() {
  return (
    <Stack alignItems='center' justifyContent='center' sx={{ minHeight: '50dvh' }}>
      <CircularProgress />
    </Stack>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route
          element={
            <TeamDrawerProvider>
              <RootLayout />
            </TeamDrawerProvider>
          }
        >
          <Route path='/' element={<HomePage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/articles' element={<ArticlesPage />} />
          <Route path='/articles/:slug' element={<ArticlePage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='*' element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
